/**
 * Copyright (c) 2021-22 Amway
 * @author Mohit Chunawala
 */

import React from "react";
import BottomSection from "../../shared-ui/bottom-section";
import InputField from "../../shared-ui/input-field";
import { withOktaAuth } from "@okta/okta-react";
import { Login } from "../../../core/authentication";
import axios from "axios";
import {
  setUserResponse,
  getPreFillDataByContentKey,
} from "../../../utils/userResponse";
import _ from "lodash";

// Infterface for NameComponent Props
interface NameComponentProps {
  backgroundImage: any;
  foregroundImage: any;
  placeholderText: string;
  questionInfo: string;
  questionTitle: string;
  validationErrors: {};
  questionLabel: string;
  enableLogin: boolean;
  language?: any;
  handleChildContinue?: any;
  handleSuccessfulContinue: any;
  recoId: any;
  contentTypeId: any;
  inputValue: (evt: any) => void;
  errorMsg: {};
}

// Infterface for NameComponent State
interface NameComponentState {
  userName: string;
  isEmptyName: boolean;
  error: string;
  updatedLanguage: any;
}

/**
 * Name component
 *
 * @namespace NameComponent
 */
class NameComponent extends React.Component<any, NameComponentState> {
  constructor(props: any) {
    super(props);
    this.state = {
      userName: "",
      isEmptyName: false,
      error: "",
      updatedLanguage: "",
    };
  }
  componentDidMount() {
    let userInfoData = localStorage.getObj("user-info");
    let loggdinUserName = userInfoData ? userInfoData.givenName : "";
    this.setState({
      userName: loggdinUserName,
    });
    this.props.handleChildContinue(this.handleError);
    this.setState({ updatedLanguage: this.props.language });
    this.setPreFillData();
  }

  componentDidUpdate = () => {
    if (this.props.language !== this.state.updatedLanguage) {
      this.setState({
        isEmptyName: false,
        userName: "",
        error: "",
        updatedLanguage: this.props.language,
      });
      this.setPreFillData();
    }
  };

  /**
   * Used to set data as per users input(existing- if any)
   */
  setPreFillData = () => {
    let recoValuesData: any = getPreFillDataByContentKey(
      this.props.contentTypeId
    );
    if (recoValuesData && !_.isEmpty(recoValuesData)) {
      this.setState({
        isEmptyName: false,
        userName: recoValuesData.values,
      });
    }
  };

  /**
   * This method is used for handling errors
   *
   */
  handleError = () => {
    const { errorMsg } = this.props;
    const { empty_error } = errorMsg;
    const { userName } = this.state;
    if (userName && userName.trim() !== "") {
      this.setState(
        {
          isEmptyName: false,
          userName: "",
        },
        () => {
          this.props.inputValue(userName);
          this.props.handleSuccessfulContinue();
          let responseData = {
            contentTypeId: this.props.contentTypeId,
            recoId: this.props.recoId,
            recoValues: userName,
            values: userName,
          };
          setUserResponse(responseData);
        }
      );
    } else {
      this.setState({
        isEmptyName: true,
        error: empty_error,
      });
    }
  };
  /**
   * This method is used for handle amway ID authentication redirects
   *
   */
  handleRedirectToLogin = async (e?: any) => {
    localStorage.setItem("previousPath", this.props.history?.location?.pathname)
    await Login(this.props.oktaAuth);
  };
  render() {
    const { userName, isEmptyName, error } = this.state;
    const { authState } = this.props;
    // const { question_label, placeholder_text } = (result && result[0]) || {};
    const {
      background_image,
      foregroundImage,
      placeholder_text,
      questionInfo,
      questionTitle,
      validation_errors,
      question_label,
      placeholderText,
      questionLabel,
      guest_info,
      login_information,
      guest_question_title,
      login_question_title,
    } = this.props;

    return (
      // <div className="main-area">
      // <div className="name-container">
      <div className="inner-wrapper">
        <div className="background-container">
          {/* account container Start */}
          {/* authState && !authState.isAuthenticated */}
          {!localStorage.getItem("okta-token-storage") ? (
            <div className="account-wrapper">
              <span className="account-msg">
                {this.props.t("common.already_have_account_label")}
              </span>
              <span
                tabIndex={0}
                role="link"
                className="account-signIn"
                onClick={this.handleRedirectToLogin}
                onKeyPress={(e: any) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.handleRedirectToLogin(e);
                  }
                }}
              >
                {this.props.t("common.sign_in_to_amway")}
              </span>
            </div>
          ) : null}
          {/* account container Ends */}

          {/* Image container Start */}
          {/* <div className="bg-image-wrapper">
            <span
              className="image"
            // style={{ backgroundImage: `url(${foregroundImage.url})` }}
            ></span>
          </div> */}
          {/* Image container Ends */}

          {/* Name input container Start */}
          <div className="name-input-wrapper">
            <div className="small-label">
              {/* {this.props.t("common.first_things_first_label")} */}
              {authState && authState.isAuthenticated
                ? login_information
                : guest_info}
            </div>
            <div className="question-label">
              {authState && authState.isAuthenticated
                ? login_question_title
                : guest_question_title}
            </div>
            {/* <InputField
              type="text"
              placeHolder={placeholderText}
              className={
                isEmptyName ? "custom-input error-input" : "custom-input"
              }
              handleInputChange={(e: any) => {
                this.setState({
                  userName: e.target.value,
                  isEmptyName: false,
                });
              }}
              inputValue={userName}
              errorMsg={error}
              isError={isEmptyName}
              inputLabel={question_label}
            /> */}
          </div>
        </div>
        {/* Name input container Ends */}
        {/* input field container Start */}
        <div className="input-container">
          <InputField
            type="text"
            placeHolder={placeholderText}
            className={
              isEmptyName
                ? "custom-input name error-input"
                : "custom-input name"
            }
            handleInputChange={(e: any) => {
              this.setState({
                userName: e.target.value,
                isEmptyName: false,
              });
            }}
            inputValue={userName}
            errorMsg={error}
            isError={isEmptyName}
            // inputLabel={"First Name"} //question_label
            inputLabel={questionLabel}
            autoFocusOnInput
          />
        </div>
        {/* input field container Ends */}
      </div>
      // </div>
    );
  }
}

export default withOktaAuth(NameComponent);
